import { t } from '@lingui/macro';

const buildReason = (attributes = {}) => {
  const {
    reason_code: code,
    reason,
    succeeded = 0,
    failed = 0,
    total = 0,
    by_status: byStatus,
  } = attributes;

  const pct = total ? Math.round((failed / total) * 100) : 0;
  const circuitBreaker =
    (byStatus?.BLOCKED_BY_CIRCUIT_BREAKER || 0) +
    (byStatus?.RE_ENQUEUED_BY_CIRCUIT_BREAKER || 0);

  switch (code) {
    case 'all_failed':
      return t`All ${total} live executions failed — erroring on every call.`;
    case 'elevated_errors':
      if (circuitBreaker > failed)
        return t`Elevated — circuit breaker tripping on ${circuitBreaker} of ${total} calls.`;
      return t`Elevated error rate — ${pct}% failing (${failed}/${total}).`;
    case 'no_activity':
      return t`No activity in the trailing window.`;
    case 'healthy':
      return '—';
    default:
      return reason || t`${failed}/${total} failed, ${succeeded} succeeded.`;
  }
};

export default buildReason;
